"use client"

import { FolderHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FolderHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FolderHeartIcon = component(Icon)({ as: FolderHeart })
